import { Unit } from '@orionprotocol/sdk';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

 
import { useLumia } from '../../context';
import { getAppChainId } from '../../redux/selectors';

export function useProvider(): Unit['provider'] | undefined {
  const appChainId = useSelector(getAppChainId);

  const { availableUnits } = useLumia();

  const provider = useMemo(
    () => availableUnits?.[appChainId]?.provider,
    [availableUnits, appChainId],
  );

  return provider;
}
